module.exports = __webpack_public_path__ + "img/jiujinfuwu_image_zj.e1cb4434.png";